import styled from "styled-components";

const Label = styled.div`
  color: ${props => props.theme.grey};
  font-size: 14px;
`;

export default Label;
